/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Total_JobsInputs */



/**
* | output |
* | --- |
* | "Total Jobs" |
*
* @param {Usage_Total_JobsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_total_jobs = /** @type {((inputs?: Usage_Total_JobsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Total_JobsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nombre total d'emplois")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gesamtzahl der Arbeitsplätze")
	if (locale === "it") return /** @type {LocalizedString} */ ("Totale posti di lavoro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Общее количество рабочих мест")
	if (locale === "es") return /** @type {LocalizedString} */ ("Total de empleos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("总职位")
	if (locale === "ja") return /** @type {LocalizedString} */ ("合計ジョブ数")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कुल नौकरियाँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Total de empregos")
	return /** @type {LocalizedString} */ ("Total Jobs")
});